import styled from "styled-components";

export const Container = styled.div`
  background-color: var(--bg-color);
  width: 100%;
  font-size: 1.5rem;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.2;
  letter-spacing: -0.5px;
  color: var(--text-color);
`;

export const ContentsWrapper = styled.div`
  display: flex;
  background-color: var(--bg-color);
  padding-left: 19px;
  padding-right: 19px;
`;

export const ImageWrapper = styled.div`
  width: 100%;
  margin-top: 0.938rem;
`;

export const TextWrapper = styled.div`
  padding: 0.875rem 0.8125rem;
  width: 100vw;
  word-wrap: break-word;
  color: var(--text-color);
  font-size: 0.8705rem;
  overflow: hidden;
`;

export const Title = styled.div`
  margin-top: 1.125rem;
  font-size: 1.25rem;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.2;
  letter-spacing: -0.5px;
  color: var(--text-color);
  padding-bottom: 0.4375rem;
`;

export const Date = styled.div`
  margin-top: 0.938rem;
  font-size: 0.688rem;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.43;
  letter-spacing: normal;
  text-align: justify;
  color: var(--text-color_sub2);
  padding-bottom: 0.4375rem;
`;

export const Description = styled.div`
  font-size: 1rem;
  color: var(--text-color_sub1);
  padding-top: 0.75rem;
  margin-top: 0.938rem;
`;

export const CloseBtn = styled.button`
  font-size: 1.5rem;
  background-color: transparent;
  border: 0;
  position: absolute;
  top: 0;
  right: 0;
  outline: 0;
  padding: 0px;
`;
